import { AppIconName } from './app-icon.types';

/** Catálogo de iconos SVG compartidos por toda la aplicación. */
export const CUSTOM_ICONS = {
  customer: 'assets/icons/customer.svg',
  contract: 'assets/icons/contract.svg',
  incident: 'assets/icons/incident.svg',
  informe_foto_stock: 'assets/icons/informe_foto_stock.svg',
  informe_foto_entidades: 'assets/icons/informe_foto_entidades.svg',
  informe_agrupado: 'assets/icons/informe_agrupado.svg',
  informe_fesbal: 'assets/icons/informe_fesbal.svg',
  informe_fega: 'assets/icons/informe_fega.svg',
  informe_fega_excel: 'assets/icons/informe_fega_excel.svg',
  informe_etiquetas_fega: 'assets/icons/informe_etiquetas_fega.svg',
  informe_registro_es_fega: 'assets/icons/informe_registro_es_fega.svg',
  informe_agenda_entidades: 'assets/icons/informe_agenda_entidades.svg',
  informe_salidas_con_beneficiarios: 'assets/icons/informe_salidas_con_beneficiarios.svg',
  informe_articulos_logisticos: 'assets/icons/informe_articulos_logisticos.svg',
  informe_voluntarios_roles_permisos: 'assets/icons/informe_voluntarios_roles_permisos.svg',
  informe_resumen_repartos: 'assets/icons/informe_resumen_repartos.svg',
  informe_detalle_repartos: 'assets/icons/informe_detalle_repartos.svg',
  informe_detalle_repartos_frio: 'assets/icons/informe_detalle_repartos_frio.svg',
  informe_umbrales_fega: 'assets/icons/informe_umbrales_fega.svg',
  informe_stock_prevision_compras: 'assets/icons/informe_stock_prevision_compras.svg',
  informe_stock_consulta_informes_prevision_compras: 'assets/icons/informe_stock_consulta_informes_prevision_compras.svg',
  informe_stock_articulos: 'assets/icons/informe_stock_articulos.svg',
  informe_stock_familias_y_subfamilias: 'assets/icons/informe_stock_familias_y_subfamilias.svg',
  informe_stock_fecha_determinada: 'assets/icons/informe_stock_fecha_determinada.svg',
  informe_stock_actual_y_necesidades: 'assets/icons/informe_stock_actual_y_necesidades.svg',
  informe_stock_comparativa_tipo_entrada: 'assets/icons/informe_stock_comparativa_tipo_entrada.svg',
  informe_stock_comparativa_tipo_salida: 'assets/icons/informe_stock_comparativa_tipo_salida.svg',
  informe_ubicacion_pales: 'assets/icons/informe_ubicacion_pales.svg',
  informe_articulos_excluidos: 'assets/icons/informe_articulos_excluidos.svg',
  calendario_entidades: 'assets/icons/calendario_entidades.svg',
  calendario_preentradas: 'assets/icons/calendario_preentradas.svg',
  csv_document: 'assets/icons/csv_document.svg',
  estanteria_normal: 'assets/icons/estanteria_normal.svg',
  estanteria_drivein: 'assets/icons/estanteria_drivein.svg',
  generar_informe: 'assets/icons/generar_informe.svg',
  mantenimiento_tablas_principales: 'assets/icons/mantenimiento_tablas_principales.svg',
  mantenimiento_proveedores: 'assets/icons/mantenimiento_proveedores.svg',
  gestion_tablas_consultar_proveedores: 'assets/icons/gestion_tablas_consultar_proveedores.svg',
  gestion_tablas_editar_proveedor: 'assets/icons/gestion_tablas_editar_proveedor.svg',
} as const;

/** Unión de nombres válidos del catálogo global. */
export type CustomIconName = AppIconName<typeof CUSTOM_ICONS>;

/** Constantes tipadas para evitar literales libres al referenciar iconos propios. */
export const CUSTOM_ICON: Record<CustomIconName, CustomIconName> = {
  customer: 'customer',
  contract: 'contract',
  incident: 'incident',
  informe_foto_stock: 'informe_foto_stock',
  informe_foto_entidades: 'informe_foto_entidades',
  informe_agrupado: 'informe_agrupado',
  informe_fesbal: 'informe_fesbal',
  informe_fega: 'informe_fega',
  informe_fega_excel: 'informe_fega_excel',
  informe_etiquetas_fega: 'informe_etiquetas_fega',
  informe_registro_es_fega: 'informe_registro_es_fega',
  informe_agenda_entidades: 'informe_agenda_entidades',
  informe_salidas_con_beneficiarios: 'informe_salidas_con_beneficiarios',
  informe_articulos_logisticos: 'informe_articulos_logisticos',
  informe_voluntarios_roles_permisos: 'informe_voluntarios_roles_permisos',
  informe_resumen_repartos: 'informe_resumen_repartos',
  informe_detalle_repartos: 'informe_detalle_repartos',
  informe_detalle_repartos_frio: 'informe_detalle_repartos_frio',
  informe_umbrales_fega: 'informe_umbrales_fega',
  informe_stock_prevision_compras: 'informe_stock_prevision_compras',
  informe_stock_consulta_informes_prevision_compras: 'informe_stock_consulta_informes_prevision_compras',
  informe_stock_articulos: 'informe_stock_articulos',
  informe_stock_familias_y_subfamilias: 'informe_stock_familias_y_subfamilias',
  informe_stock_fecha_determinada: 'informe_stock_fecha_determinada',
  informe_stock_actual_y_necesidades: 'informe_stock_actual_y_necesidades',
  informe_stock_comparativa_tipo_entrada: 'informe_stock_comparativa_tipo_entrada',
  informe_stock_comparativa_tipo_salida: 'informe_stock_comparativa_tipo_salida',
  informe_ubicacion_pales: 'informe_ubicacion_pales',
  informe_articulos_excluidos: 'informe_articulos_excluidos',
  calendario_entidades: 'calendario_entidades',
  calendario_preentradas: 'calendario_preentradas',
  csv_document: 'csv_document',
  estanteria_normal: 'estanteria_normal',
  estanteria_drivein: 'estanteria_drivein',
  generar_informe: 'generar_informe',
  mantenimiento_tablas_principales: 'mantenimiento_tablas_principales',
  mantenimiento_proveedores: 'mantenimiento_proveedores',
  gestion_tablas_consultar_proveedores: 'gestion_tablas_consultar_proveedores',
  gestion_tablas_editar_proveedor: 'gestion_tablas_editar_proveedor',
};
